'use strict';
import {apiConfig} from '@stencil/hotels-config';
import Megatron from '@stencil/megatron';

function prepareCountryCodesUrl() {
  return '/common/countrycode/';
}

const countryCodesApi = async () => {
  const countryApi = prepareCountryCodesUrl();
  const url = `${apiConfig.__DEXTER__}${countryApi}`;
  const response = await Megatron({
    name: 'Country Code Api',
    type: 'GET',
    url,
    credentials: 'same-origin',
    headers: {'Content-Type': 'charset=UTF-8'},
  });

  return response;
};

export default countryCodesApi;
